import * as React from "react"
import { Input, InputProps, Flex, Box, Text } from "@chakra-ui/react"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"
import { isRGBAcolor, replaceOpacity, getOpacity } from "../../../util"
import { useTranslation } from "react-i18next"

interface CommonIconProps extends InputProps {
  error?: string
  errorTextColor?: string
  isCustomInput?: boolean
  isCustomPlaceholder?: boolean
  stylesContainer?: React.CSSProperties
}

export const CommonInput: React.FC<CommonIconProps> = ({
  error,
  errorTextColor,
  isCustomInput,
  placeholder,
  isCustomPlaceholder,
  id,
  stylesContainer,
  ...props
}) => {
  const roomStyles = useRecoilValue(brandingSelector)
  const { t } = useTranslation()
  const borderColor = React.useMemo<string>(() => {
    if (error) {
      return roomStyles?.servicePanelElementWarningText ?? "red"
    }
    if (isRGBAcolor(roomStyles?.servicePanelElementBorder)) {
      return getOpacity(roomStyles?.servicePanelElementBorder) > 0.3
        ? replaceOpacity(
            roomStyles?.servicePanelElementBorder,
            getOpacity(roomStyles?.servicePanelElementBorder) - 0.3
          )
        : replaceOpacity(roomStyles?.servicePanelElementBorder, 0.1)
    }
    return `${roomStyles?.servicePanelElementBorder}b3` ?? "inherit"
  }, [
    error,
    roomStyles?.servicePanelElementBorder,
    roomStyles?.servicePanelElementWarningText
  ])

  return (
    <Flex pos="relative" width="100%" style={stylesContainer}>
      {error && (
        <Box
          right="0px"
          top="-17px"
          pos="absolute"
          fontSize="0.7rem"
          fontWeight="700"
          color={
            errorTextColor ??
            roomStyles?.servicePanelElementWarningText ??
            "red"
          }
        >
          {t(error)}
        </Box>
      )}
      {isCustomPlaceholder && (
        <Text
          transform="translate(0%, -50%)"
          top="50%"
          color="#3f4c5b"
          opacity={0.5}
          zIndex="1000000"
          position="absolute"
          left="20px"
          onClick={() => {
            document.getElementById(id).focus()
          }}
        >
          {t(placeholder)}
        </Text>
      )}
      <Input
        id={id}
        type="text"
        fontWeight={400}
        lineHeight={1.5}
        placeholder={placeholder}
        boxShadow="none !important"
        color={roomStyles.servicePanelElementPrimaryText ?? "#495057"}
        backgroundColor={roomStyles?.servicePanelElementBackground ?? "#e9ecef"}
        borderColor={borderColor}
        border="2px"
        _hover={{
          borderColor: error
            ? roomStyles?.servicePanelElementWarningText ?? "red"
            : roomStyles?.servicePanelElementBorder ?? "gray.300"
        }}
        _focus={{
          borderColor: error
            ? roomStyles?.servicePanelElementWarningText ?? "red"
            : roomStyles?.servicePanelElementBorder ?? "gray.500"
        }}
        _placeholder={{
          color: roomStyles.servicePanelElementPrimaryText ?? "#495057",
          opacity: 0.5
        }}
        {...props}
      />
    </Flex>
  )
}
